import React from "react";
import SubHeader from "../../../common/subHeader";
import ATable from "../../../common/table";

const columns = [
  {
    header: "Action",
    accessor: "action",
    width: 500
  },
  {
    header: "Performed By",
    accessor: "performedBy"
  },
  {
    header: "Performed On",
    accessor: "performedOn"
  }
];

const CaseHistory = ({ caseDetails }) => (
  <div>
    <SubHeader title="Case History" />
    <hr />
    {caseDetails &&
      caseDetails.caseHistory && (
        <ATable
          className="-striped -highlight"
          tableData={caseDetails.caseHistory}
          columns={columns}
          defaultPageSize={10}
        />
      )}
  </div>
);

export default CaseHistory;



// WEBPACK FOOTER //
// ./src/components/discover/cases/caseDetail/CaseHistory.js